var _rect, _line, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _rect6, _circle4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorTc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 258,
    viewBox: "0 0 390 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 338,
    height: 210,
    rx: 3,
    fill: "white",
    stroke: "#D3D9DD",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 19,
    x2: 340,
    y2: 19,
    stroke: "#D3D9DD",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 10.5,
    r: 2.5,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 10.5,
    r: 2.5,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 10.5,
    r: 2.5,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 65,
    width: 144,
    height: 56,
    rx: 2,
    fill: "#F6F6F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 65,
    width: 144,
    height: 56,
    rx: 2,
    fill: "#F6F6F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 31,
    width: 302,
    height: 20,
    rx: 2,
    fill: "#F6F6F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 135,
    width: 144,
    height: 56,
    rx: 2,
    fill: "#F6F6F6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 135,
    width: 144,
    height: 56,
    rx: 2,
    fill: "#F6F6F6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 208,
    r: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340 172C320.128 172 304 188.128 304 208C304 227.872 320.128 244 340 244C359.872 244 376 227.872 376 208C376 188.128 359.872 172 340 172ZM343.6 226H336.4V218.8H343.6V226ZM343.6 211.6H336.4V190H343.6V211.6Z",
    fill: "#F55641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTc);
export default __webpack_public_path__ + "static/media/errorTC.e131239a160e4b76ca753fe80e994337.svg";
export { ForwardRef as ReactComponent };